<app-view-title Title="{{ 'Intellitrailer.Rental.ReturnComplete.Headline' | translate : 'Return complete!' }}" [isSoftSplit]="true"></app-view-title>
<view-content [centered]="true">
  @if(!loading) {
  <ng-container>
    <app-information-screen [centered]="true"
                            primaryContent="{{ primaryContent }}"
                            image="/assets/Images/big-checkbox-green.png"
                            [showInvite]="hasActiveCampaign" [discounts]="discount">


    </app-information-screen>
  </ng-container>
  }
  @else if (loading) {
  <div class="spinner-container">
    <mat-spinner diameter="70" mode="indeterminate"></mat-spinner>
    <p>{{ 'Intellitrailer.Rental.ReturnComplete.LoadingReturn' | translate : 'Loading...' }}</p>
  </div>
  }
</view-content>
<view-actions mode="white">
  @if(!loading) {
  <button mat-raised-button (click)="confirm()">{{ 'Intellitrailer.Rental.ReturnComplete.cmdConfirm' | translate : 'OK' }}</button>
  }
</view-actions>

